import { render, staticRenderFns } from "./rateEdit.vue?vue&type=template&id=3875dbf2&scoped=true&"
import script from "./rateEdit.vue?vue&type=script&lang=js&"
export * from "./rateEdit.vue?vue&type=script&lang=js&"
import style0 from "./rateEdit.vue?vue&type=style&index=0&id=3875dbf2&lang=stylus&scoped=true&"
import style1 from "./rateEdit.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875dbf2",
  null
  
)

export default component.exports